export default "__VITE_ASSET__7c2feef3__"